import React, { useState } from "react";
import { FaCity, FaStore, FaUser, FaPhone, FaEnvelope, FaMapMarkerAlt, FaCommentDots } from "react-icons/fa";
import { MdCategory } from "react-icons/md";

const JoinUsForm = () => {
  const [formData, setFormData] = useState({
    city: "",
    category: "",
    state: "",
    pincode: "",
    shopName: "",
    ownerName: "",
    phonePrimary: "",
    phoneSecondary: "",
    email: "",
    address: "",
    knowUs: "",
    feedback: "",
  });

  const [loading, setLoading] = useState(false);

  const categories = [
    "Restaurants",
    "Condiments",
    "Kirana Stores",
    "Coffee or Tea Shops",
    "Sweet Shops",
    "General Stores",
    "Others",
  ];

  const knowUsOptions = [
    "Social Media",
    "Friends / Family",
    "Advertisement",
    "Search Engine",
    "Other",
  ];

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await fetch(
        "https://dgl-core-9x7.dailygolive.in/api/joinus",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
        }
      );

      if (response.ok) {
        alert("✅ Form submitted successfully!");
        setFormData({
          city: "",
          category: "",
          state: "",
          pincode: "",
          shopName: "",
          ownerName: "",
          phonePrimary: "",
          phoneSecondary: "",
          email: "",
          address: "",
          knowUs: "",
          feedback: "",
        });
      } else {
        alert("❌ Failed to submit form. Please try again.");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("⚠️ An error occurred while submitting the form.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4 py-12">
      <div className="w-full max-w-4xl bg-white shadow-lg rounded-xl p-10 border border-gray-200">
        <h2 className="text-2xl font-semibold mb-2 text-gray-800 text-center">
          Join Us
        </h2>
        <p className="text-center text-gray-600 mb-8">
          Please fill out the form below. Our team will contact you shortly.
        </p>

        <form
          onSubmit={handleSubmit}
          className="grid grid-cols-1 md:grid-cols-2 gap-6"
        >
          {/* CITY */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              <FaCity className="inline mr-1 text-green-600" /> City <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              name="city"
              value={formData.city}
              onChange={handleChange}
              pattern="[A-Za-z\s]+"
              className="w-full border border-gray-300 rounded-lg px-4 py-2.5 focus:outline-none focus:ring-2 focus:ring-green-600"
              placeholder="Enter city"
              required
            />
          </div>

          {/* CATEGORY */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              <MdCategory className="inline mr-1 text-green-600" /> Category <span className="text-red-500">*</span>
            </label>
            <select
              name="category"
              value={formData.category}
              onChange={handleChange}
              className="w-full border border-gray-300 rounded-lg px-4 py-2.5 bg-white focus:outline-none focus:ring-2 focus:ring-green-600"
              required
            >
              <option value="">Select category</option>
              {categories.map((cat, index) => (
                <option key={index} value={cat}>
                  {cat}
                </option>
              ))}
            </select>
          </div>

          {/* STATE */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              <FaMapMarkerAlt className="inline mr-1 text-green-600" /> State <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              name="state"
              value={formData.state}
              onChange={handleChange}
              pattern="[A-Za-z\s]+"
              className="w-full border border-gray-300 rounded-lg px-4 py-2.5 focus:outline-none focus:ring-2 focus:ring-green-600"
              placeholder="Enter state"
              required
            />
          </div>

          {/* PINCODE */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              <FaMapMarkerAlt className="inline mr-1 text-green-600" /> Pincode <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              name="pincode"
              value={formData.pincode}
              onChange={handleChange}
              pattern="\d{6}"
              maxLength="6"
              className="w-full border border-gray-300 rounded-lg px-4 py-2.5 focus:outline-none focus:ring-2 focus:ring-green-600"
              placeholder="Enter 6-digit pincode"
              required
            />
          </div>

          {/* SHOP NAME */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              <FaStore className="inline mr-1 text-green-600" /> Shop Name <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              name="shopName"
              value={formData.shopName}
              onChange={handleChange}
              pattern="[A-Za-z\s]+"
              className="w-full border border-gray-300 rounded-lg px-4 py-2.5 focus:outline-none focus:ring-2 focus:ring-green-600"
              placeholder="Enter shop name"
              required
            />
          </div>

          {/* OWNER NAME */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              <FaUser className="inline mr-1 text-green-600" /> Owner Name <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              name="ownerName"
              value={formData.ownerName}
              onChange={handleChange}
              pattern="[A-Za-z\s]+"
              className="w-full border border-gray-300 rounded-lg px-4 py-2.5 focus:outline-none focus:ring-2 focus:ring-green-600"
              placeholder="Enter owner name"
              required
            />
          </div>

          {/* PHONE PRIMARY */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              <FaPhone className="inline mr-1 text-green-600" /> Phone Primary (WhatsApp) <span className="text-red-500">*</span>
            </label>
            <input
              type="tel"
              name="phonePrimary"
              value={formData.phonePrimary}
              onChange={handleChange}
              pattern="\d{10}"
              maxLength="10"
              className="w-full border border-gray-300 rounded-lg px-4 py-2.5 focus:outline-none focus:ring-2 focus:ring-green-600"
              placeholder="Enter 10-digit WhatsApp number"
              required
            />
          </div>

          {/* PHONE SECONDARY */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              <FaPhone className="inline mr-1 text-green-600" /> Phone Secondary <span className="text-red-500">*</span>
            </label>
            <input
              type="tel"
              name="phoneSecondary"
              value={formData.phoneSecondary}
              onChange={handleChange}
              pattern="\d{10}"
              maxLength="10"
              className="w-full border border-gray-300 rounded-lg px-4 py-2.5 focus:outline-none focus:ring-2 focus:ring-green-600"
              placeholder="Enter 10-digit secondary number"
              required
            />
          </div>

          {/* EMAIL */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              <FaEnvelope className="inline mr-1 text-green-600" /> Email <span className="text-red-500">*</span>
            </label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className="w-full border border-gray-300 rounded-lg px-4 py-2.5 focus:outline-none focus:ring-2 focus:ring-green-600"
              placeholder="Enter email address"
              required
            />
          </div>

          {/* ADDRESS */}
          <div className="md:col-span-2">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              <FaMapMarkerAlt className="inline mr-1 text-green-600" /> Address <span className="text-red-500">*</span>
            </label>
            <textarea
              name="address"
              value={formData.address}
              onChange={handleChange}
              rows="3"
              className="w-full border border-gray-300 rounded-lg px-4 py-2.5 focus:outline-none focus:ring-2 focus:ring-green-600"
              placeholder="Enter shop address"
              required
            ></textarea>
          </div>

          {/* HOW YOU KNOW ABOUT US */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              <FaCommentDots className="inline mr-1 text-green-600" /> How did you hear about us? <span className="text-red-500">*</span>
            </label>
            <select
              name="knowUs"
              value={formData.knowUs}
              onChange={handleChange}
              className="w-full border border-gray-300 rounded-lg px-4 py-2.5 bg-white focus:outline-none focus:ring-2 focus:ring-green-600"
              required
            >
              <option value="">Select option</option>
              {knowUsOptions.map((opt, index) => (
                <option key={index} value={opt}>
                  {opt}
                </option>
              ))}
            </select>
          </div>

          {/* FEEDBACK */}
          <div className="md:col-span-2">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              <FaCommentDots className="inline mr-1 text-green-600" /> Feedback <span className="text-red-500">*</span>
            </label>
            <textarea
              name="feedback"
              value={formData.feedback}
              onChange={handleChange}
              rows="3"
              className="w-full border border-gray-300 rounded-lg px-4 py-2.5 focus:outline-none focus:ring-2 focus:ring-green-600"
              placeholder="Write your feedback..."
              required
            ></textarea>
          </div>

          {/* SUBMIT */}
          <div className="md:col-span-2 flex justify-center mt-4">
            <button
              type="submit"
              disabled={loading}
              className="bg-green-600 hover:bg-green-700 transition text-white px-8 py-2.5 rounded-lg font-medium shadow-sm disabled:opacity-60"
            >
              {loading ? "Submitting..." : "Submit Form"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default JoinUsForm;
